import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useFetchUserPageViews(email, from, to) {
  const { oktaAuth } = useOktaAuth();
  const dataKey = "FetchUserPageViews";

  return useQuery({
    queryKey: [dataKey, email, from, to],
    queryFn: async ({ signal }) => {
      const accessToken = oktaAuth.getAccessToken();
      const response = await axios.get("api/Telemetry/user-page-views", {
        params: { email, from, to },
        headers: { Authorization: `Bearer ${accessToken}` },
        signal,
      });
      return response.data;
    },
    enabled: Boolean(email && from && to),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
